module.exports = __webpack_public_path__ + "img/L_316_324.f35e21d3.png";